export default __webpack_public_path__ + "static/media/info-concierge.inline.f6429443.svg";